/**
 * @Author: DKing
 * @Desc: 接口地址
 * @Date: 2019-07-15
 */

export const INTERFACE_URL = {
  INFORMATION_LIST: '/news/findPage', //新闻资讯
  INFORMATION_DETAIL: '/news/findDetail', // 新闻详情
  MAKE_APPOINT: '/ow/forward', //预约
  CALL_OC: '/call/oc', //百度转化追踪-官网电话点击
  FIND_PROVINCE_OR_CITY: '/ow/find/province/or/city', //查询省、市接口
};


// WEBPACK FOOTER //
// ./src/service/interface_urls.js